import actions from './actions';
import mutations from './mutations';
import getters from './getters';
import state from './state';

export default {
	actions,
	mutations,
	getters,
	state
};



// WEBPACK FOOTER //
// ./sources/app/sample/store/index.js